var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45.338 45.338",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.329,5.629c-0.927,0-1.819,0.209-2.651,0.622c-10.119,4.997-16.997,14.53-20.585,20.624 l-6.626-4.694c-1.019-0.723-2.218-1.105-3.465-1.105c-1.944,0-3.776,0.947-4.899,2.532C-0.81,26.307-0.17,30.06,2.53,31.972 l8.174,5.791c1.797,1.273,3.86,1.946,5.967,1.946c0.74,0,1.484-0.084,2.214-0.25c2.853-0.649,5.348-2.567,6.845-5.262 c2.614-4.71,8.204-13.207,16.262-17.187c1.438-0.709,2.512-1.936,3.026-3.454c0.515-1.518,0.407-3.146-0.303-4.583 C43.696,6.91,41.633,5.629,39.329,5.629z M42.176,12.592c-0.258,0.759-0.795,1.373-1.514,1.728 c-8.789,4.34-14.772,13.404-17.557,18.42c-1.083,1.951-2.864,3.333-4.888,3.794c-1.976,0.448-4.045,0.011-5.78-1.219l-8.174-5.79 c-1.35-0.956-1.67-2.832-0.714-4.182c0.562-0.793,1.479-1.267,2.452-1.267c0.622,0,1.221,0.191,1.73,0.553l9.34,6.616l0.812-1.462 c3.122-5.615,9.887-15.789,20.122-20.843c0.417-0.206,0.861-0.311,1.322-0.311c1.153,0,2.186,0.641,2.695,1.672 C42.379,11.02,42.433,11.834,42.176,12.592z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTick);
export default __webpack_public_path__ + "static/media/right-tick.3cd65cfe7a35695d6fba69f1a3edacb1.svg";
export { ForwardRef as ReactComponent };